import React from 'react'
import PropTypes from 'prop-types'

const MarkCompleteButtonIcon = ({
  fillColor = '#5D7217',
  height = '16px',
  width = '16px',
  ...props
}) => {
  return (
    <svg
      height={height}
      version="1.1"
      viewBox="0 0 17 17"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        id="UI-Style-guide"
        stroke="none"
        strokeWidth="1"
      >
        <g
          id="Button/UI/PrimarySecondary/clicked"
          strokeWidth="1.5"
          transform="translate(-40.5, -13)"
        >
          <g id="icon-and-label" transform="translate(41, 11)">
            <g id="Icon/UI/Done2/default" transform="translate(0, 2.5)">
              <circle
                cx="8"
                cy="8"
                fill={fillColor}
                id="Oval"
                r="7.25"
                stroke={fillColor}
              />
              <polyline
                id="Path-34"
                points="4.74312412 8.33060051 7.2 11.2837426 11.2338614 4.82931895"
                stroke="#FFFFFF"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

MarkCompleteButtonIcon.propTypes = {
  fillColor: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
}

export default MarkCompleteButtonIcon
